
export default {
  name: 'StarRatingLight',
  props: {
    rating: {
      type: [Number, String],
      default: 0,
    },
    size: {
      type: Number,
      default: 15,
    },
    gap: {
      type: Number,
      default: 2,
    },
  },
  computed: {
    value() {
      return Math.min(5, Math.max(0, Number(this.rating) || 0))
    },
    label() {
      return Math.round(this.value * 10) / 10
    },
    fillPercent() {
      const cell = this.size + this.gap
      const total = cell * 5 - this.gap
      const whole = Math.floor(this.value)
      const filled = whole * cell + (this.value - whole) * this.size
      return Math.round((filled / total) * 1000) / 10
    },
  },
}
